import type { TFunc } from "../i18n";

export function formatAuthError(error: unknown, t: TFunc, fallback: string): string {
  const message = error instanceof Error ? error.message : fallback;

  if (/verification code/i.test(message)) {
    if (/could not send/i.test(message)) {
      return t("auth.sendVerificationCodeFailed");
    }
    return t("auth.invalidVerificationCode");
  }

  return message;
}
